import {
    getUniqFieldId,
} from 'app/common/DomainObject'
import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    DailyOpsFields,
} from '../dailyOps.types'

const config: SkyNetTableConfig<DailyOpsFields> = {
    tabs: [{
        name: 'Upcoming Container Selection',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'from',
                filterField: 'from',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'to',
                filterField: 'to',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'originLocationLocationName',
                filterField: 'originLocationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'customerLocationName',
                filterField: 'customerLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                labelKey: 'Prebooking.pricingAccount',
                filterType: FilterType.Array,
            },
            {
                name: 'mawbNumber',
                filterField: 'mawbNumber',
                filterType: FilterType.Array,
            },
            {
                name: 'requestedHandover',
                filterField: 'requestedHandover',
                filterType: FilterType.Array,
                headerProps: {
                    children: 'Requested Handover',
                },
                componentName: 'DateTimeCell',
            },
            {
                name: 'plannedPickup',
                filterField: 'plannedPickup',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'requestedHandover',
                id: getUniqFieldId('requestedHandover', 1),
                componentName: 'ContainerSelectionUntil',
                headerProps: {
                    children: 'Remaining / Overdue',
                },
                sorting: false,
            },
        ],
    }],
}

export default config
